import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { Warning } from '@material-ui/icons';

const NoAvailableLicensesMessage = () => {
  const classes = useStyles();
  const { t } = useTranslation('NoAvailableLicensesMessage');

  return (
    <Box className={classes.container}>
      <Warning className={classes.warningIcon} />
      <Typography variant="subtitle1" className={classes.subtitleText}>
        {t('No more licenses available')}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    background: '#FFFCF8',
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: theme.typography.pxToRem(4),
    display: 'inline-block',
    padding: `${theme.typography.pxToRem(0)} ${theme.typography.pxToRem(8)}`
  },
  subtitleText: {
    display: 'inline-block',
    padding: `${theme.typography.pxToRem(0)} ${theme.typography.pxToRem(5)}`
  },
  warningIcon: {
    bottom: theme.typography.pxToRem(-2),
    color: theme.palette.warning.main,
    fontSize: theme.typography.pxToRem(16),
    position: 'relative'
  }
}));

export default NoAvailableLicensesMessage;
